import './instructions.scss';
import { openiPhoneHaikuSetup, openiPadCantoSetup, openAndroidHaikuSetup, download2FAGuide } from '../../links';
import arrowUp from '../../assets/arrow-up.svg';

const Instructions: React.FC = () => (
    <div className="instructions">
        <div className="setup">
            <h1 className="setup-text">Setup Instructions</h1>
        </div>
        <div className="steps">
            <div className="sideline"></div>
            <div className="step1">
                <div className="step1-number">
                    <h3 className="step1-number-text">1</h3>
                </div>
                <div className="step1-text">
                    <h3 className="step1-text-title">Download the app</h3>
                    <p className="step1-text-content">Download the Haiku/Canto app for iPhone, iPad or Android.</p>
                </div>
            </div>
            <div className="step2">
                <div className="step2-number">
                    <h3 className="step2-number-text">2</h3>
                </div>
                <div className="step2-text">
                    <h3 className="step2-text-title">Configure Haiku or Canto</h3>
                    <p className="step2-text-content">After downloading the app, choose the link below that matches your device.</p>
                    <div className="step2-text-frame">
                        <button className="step2-text-frame-link" onClick={openiPhoneHaikuSetup}>
                            <div className="step2-text-frame-link-frame">
                                <p className="step2-text-frame-link-frame-text">Epic Haiku - iPhone (setup)</p>
                                <img src={arrowUp} alt="Epic Haiku - iPhone (setup)" className="step2-text-frame-link-frame-interface-arrow-up" />
                            </div>
                            <div className="step2-text-frame-link-line"></div>
                        </button>
                        <button className="step2-text-frame-link" onClick={openiPadCantoSetup}>
                            <div className="step2-text-frame-link-frame">
                                <p className="step2-text-frame-link-frame-text">Epic Canto - iPad (setup)</p>
                                <img src={arrowUp} alt="Epic Canto - iPad (setup)" className="step2-text-frame-link-frame-interface-arrow-up" />
                            </div>
                            <div className="step2-text-frame-link-line"></div>
                        </button>
                        <button className="step2-text-frame-link" onClick={openAndroidHaikuSetup}>
                            <div className="step2-text-frame-link-frame">
                                <p className="step2-text-frame-link-frame-text">Epic Haiku - Android (setup)</p>
                                <img src={arrowUp} alt="Epic Haiku - Android  (setup)" className="step2-text-frame-link-frame-interface-arrow-up" />
                            </div>
                            <div className="step2-text-frame-link-line"></div>
                        </button>
                    </div>
                </div>
            </div>
            <div className="step3">
                <div className="step3-number">
                    <h3 className="step3-number-text">3</h3>
                </div>
                <div className="step3-text">
                    <h3 className="step3-text-title">Set up Two Factor Authentication (2FA)</h3>
                    <p className="step3-text-content">Download the 2FA guide.</p>
                    <div className="step3-text-frame">
                        <button className="step3-text-frame-link" onClick={download2FAGuide}>
                            <div className="step3-text-frame-link-frame">
                                <p className="step3-text-frame-link-frame-text">Two Factor Authentication guide</p>
                                <img src={arrowUp} alt="Two Factor Authentication guide" className="step3-text-frame-link-frame-interface-arrow-up" />
                            </div>
                            <div className="step3-text-frame-link-line"></div>
                        </button>
                    </div>
                </div>
            </div>
            <div className="step4">
                <div className="step4-number">
                    <h3 className="step4-number-text">4</h3>
                </div>
                <div className="step4-text">
                    <h3 className="step4-text-title">Sign in using your Epic Hyperspace credentials</h3>
                </div>
            </div>
        </div>
    </div>
);

export default Instructions;
